import { render, staticRenderFns } from "./CreateBranchModal.vue?vue&type=template&id=abd95224&"
import script from "./CreateBranchModal.vue?vue&type=script&lang=js&"
export * from "./CreateBranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports